export { default as ChannelListTemplate } from './ChannelListTemplate';
export { default as ChannelEditTemplate } from './ChannelEditTemplate';
export { default as WarehouseCodesTemplate } from './WarehouseCodesTemplate';
export { default as CustomLabelTemplate } from './CustomLabelTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/channel/pages/index.js